import LazyLoadForceReadPdf from "components/PDF/LazyLoadForceReadPdf";
import React, { useCallback } from "react";

function OffshoreTermAndConditions({ code, close, state, actions, visible }) {
  const onAccept = useCallback(() => {
    close();
    actions?.onAccept && actions.onAccept(code);
  }, [close, actions, code]);

  const onCancel = useCallback(() => {
    close();
    actions?.onCancel && actions.onCancel();
  }, [close, actions]);

  return (
    <LazyLoadForceReadPdf
      pdfUrl={state?.pdfUrl}
      visible={visible && !!state?.pdfUrl}
      goBack={onCancel}
      onAccept={onAccept}
      title={null}
      adjustPdfViewSize={-47}
      portalClassName="pdf-summary-key-risk-info"
    />
  );
}

export default OffshoreTermAndConditions;
